import React from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from '../../../../../components/ui/Button';
import { DateRangePicker } from '../../../../../components/ui/DateRangePicker';

/**
 * @param {object} props
 * @param {object} props.filters - The slice's `filters`
 * @param {(patch: object) => void} props.onFilterChange
 * @param {() => void} props.onReload
 * @param {boolean} props.isLoading
 * @param {boolean} props.isStale - Something moved since the last fetch
 */
export const DashboardFilters = ({
  filters,
  onFilterChange,
  onReload,
  isLoading,
  isStale,
}) => (
  <div data-testid="dashboard-filters" className="flex flex-col md:flex-row flex-wrap items-center gap-4">
    <DateRangePicker
      startDate={filters.start_date}
      endDate={filters.end_date}
      onChange={onFilterChange}
    />

    <div className="flex items-center gap-3 md:ml-auto">
      {/* Only shown when the backend said something moved and the automatic
          refetch has not caught up. */}
      {isStale && !isLoading && (
        <span className="text-xs font-medium text-warning">Hay cambios sin cargar</span>
      )}

      <Button
        variant="secondary"
        size="sm"
        icon={RefreshCw}
        loading={isLoading}
        loadingLabel="Actualizando..."
        onClick={onReload}
      >
        Recargar
      </Button>
    </div>
  </div>
);
